import React from 'react'

export const ExclamationCircle = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      d='M19.0713 4.92907C15.1656 1.02386 8.83319 1.02343 4.92711 4.92907C1.02147 8.83471 1.02191 15.1671 4.92711 19.0732C8.83276 22.978 15.1652 22.9784 19.0713 19.0732C22.9765 15.1671 22.976 8.83514 19.0713 4.92907Z'
    />
    <path
      d='M12 16.5469V12.9102'
      stroke='#E5FAFA'
      stroke-width='2.72754'
      stroke-linecap='round'
    />
    <path
      d='M11.3997 7.90869C11.3997 7.5321 11.7049 7.22681 12.0815 7.22681C12.4581 7.22681 12.7634 7.5321 12.7634 7.90869C12.7634 8.28529 12.4581 8.59058 12.0815 8.59058C11.7049 8.59058 11.3997 8.28529 11.3997 7.90869Z'
      stroke='#E5FAFA'
      stroke-width='1.36377'
    />
  </svg>
)
